var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 14,
  viewBox: "0 0 8 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.003 0C7.553 0 8 .45 8 1.007v11.986C8 13.55 7.547 14 7.003 14H.997C.447 14 0 13.55 0 12.993V1.007C0 .45.453 0 .997 0zM5 12H3v1h2zM7 2H1v9h6z"
})));
export default SvgMobile;